export default __webpack_public_path__ + "static/media/NoData.fd8d5b4c.svg";